import { validateShippingAddress } from "@/lib/shipping-text";
import { useMutation } from "@tanstack/react-query";
import { useSession } from "@/services/auth0/session";
import axios from "axios";
import type {
  GetQuoteRequest,
  GetQuoteResponse,
  PricingOption,
} from "@/api.types.v2";

const API_URL = import.meta.env.VITE_API_URL;

/**
 * Pricing-redesign client for `POST /api/v2/pricing/get-quote`.
 *
 * Replaces the retired bundled-pricing flow. The quote endpoint returns split
 * `labelPriceCents` + `pickupPriceCents` so the UI can render pickup as a
 * separate add-on.
 */
export function useGetQuote() {
  const { token } = useSession();

  return useMutation({
    mutationFn: async (request: GetQuoteRequest): Promise<GetQuoteResponse> => {
      validateShippingAddress(request.shipFrom, "Sender");
      validateShippingAddress(request.shipTo, "Recipient");
      const { data } = await axios.post<{
        success: boolean;
        data: GetQuoteResponse;
      }>(`${API_URL}/api/v2/pricing/get-quote`, request, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return data.data;
    },
  });
}

export type { PricingOption, GetQuoteResponse };
